import React, { useRef, useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "../Styles/Otp_verification.css";
import { enable_user_account, log_in } from "../api/serverWrapper";
import {
  AGENT_LOGIN,
  CLIENT_LOGIN,
  CLIENT_PROFILE_CODE,
  PHNO,
  PROFILE_LOGIN,
  USER_ID,
} from "../utils/store-data-constants";
import { getData, saveData } from "../utils/store-data";
import UserSystemRole from "../components/UserSystemRole";
import { useMasterData } from "../context/MasterDataContext";

const Otp_verification = () => {
  const [phoneNumber, setPhoneNo] = useState("");
  const { selectedCountryCode } = useMasterData();
  const navigate = useNavigate();
  const inputsRef = useRef([]);
  const [otp, setOtp] = useState(["", "", "", ""]);
  const location = useLocation();

  const [disabledUserId, setDisabledUserId] = useState(null);

  const [accountDeletedPopup, setAccountDeletedPopup] = useState(false);
  const [accountDisabledPopup, setAccountDisabledPopup] = useState(false);
  const [isEnabling, setIsEnabling] = useState(false);

  const handleInputChange = (e, index) => {
    const value = e.target.value.replace(/[^0-9]/g, "");
    if (value.length > 1) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value && index < inputsRef.current.length - 1) {
      inputsRef.current[index + 1].focus();
    }
    if (!value && index > 0) {
      inputsRef.current[index - 1].focus();
    }

    if (newOtp.every((digit) => digit !== "")) {
      login();
    }
  };

  useEffect(() => {
    loadPHno();
  }, []);

  async function loadPHno() {
    let phno = await getData(PHNO);
    setPhoneNo(phno);
  }

  const login = async () => {
    let phno = await getData(PHNO);
    let data = {
      PhoneNumber: phno,
      CountyCode: selectedCountryCode,
    };

    console.log(data);

    try {
      let resp = await log_in(data);
      console.log(resp);

      if (resp?.data) {
        // Deleted Account
        if (resp.data.IsDeleted) {
          setAccountDeletedPopup(true);
          return;
        }

        // Disabled Account
        if (!resp.data.IsActive) {
          setDisabledUserId(resp.data.UserId);
          setAccountDisabledPopup(true);
          return;
        }
        await saveData(USER_ID, resp.data.UserId);
        if (resp.data.SystemRole === UserSystemRole.AGENT.id) {
          await saveData(AGENT_LOGIN, true);
          await saveData(PROFILE_LOGIN, false);
          await saveData(CLIENT_LOGIN, false);
          navigate("/dashboard");
        } else if (resp.data.SystemRole === UserSystemRole.CLIENT.id) {
          await saveData(AGENT_LOGIN, false);
          await saveData(PROFILE_LOGIN, false);
          await saveData(CLIENT_LOGIN, true);
          navigate("/dashboard");
        } else if (Number(resp.data.SystemRole) === UserSystemRole.PROFILE.id) {
          //  await saveData(AGENT_LOGIN, false);
          // await saveData(PROFILE_LOGIN, true);
          // await saveData(CLIENT_LOGIN, false);
          // navigate("/dashboard");

          console.log(resp?.data?.profile?.AgentId);

          // if (
          //   resp?.data?.profile?.AgentId === null &&
          //   !resp?.data?.profile?.AgentId
          // ) {
          //   await saveData(AGENT_LOGIN, false);
          //   await saveData(CLIENT_LOGIN, false);
          //   await saveData(PROFILE_LOGIN, true);
          //   await saveData(CLIENT_PROFILE_CODE, resp.data.profile.ClientCode);
          //   navigate("/profileforclient", {
          //     state: { client: resp.data.profile },
          //   });
          // } else
          if (resp?.data?.profile?.IsProfileActivated) {
            await saveData(USER_ID, resp.data.UserId);
            await saveData(AGENT_LOGIN, false);
            await saveData(CLIENT_LOGIN, false);
            await saveData(PROFILE_LOGIN, true);
            await saveData(CLIENT_PROFILE_CODE, resp.data.profile.ClientCode);
            navigate("/profileforclient", {
              state: { client: resp.data.profile },
            });
          } else {
            navigate("/profilelogin");
          }
        } else {
          alert("Invalid Phone Number");
          navigate("/home");
        }
      } else {
        navigate("/terms-and-conditions");
      }

      // } else if (loginType === "Agent") {
      //   navigate("/employee_sign_in");
      // }
      // else if (loginType === "Client") {
      //   navigate("/client_setup");
      // }
    } catch (error) {
      console.log(error);
    }
  };

  const handleReactivateAccount = async () => {
    try {
      setIsEnabling(true);

      const resp = await enable_user_account({
        UserId: disabledUserId,
      });

      console.log(resp);

      if (resp?.code === 200) {
        setAccountDisabledPopup(false);

        setTimeout(() => {
          navigate("/home");
        }, 1000);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsEnabling(false);
    }
  };

  return (
    <div className="otp-page">
      {/* Left Panel */}
      <div className="left-panel">
        <div className="curve-image"></div>
        <img
          src={require("../assests/images/otp_verification_logo.png")}
          alt="WedLuk Logo"
          className="logo"
        />
        <p className="tagline">Matirmonial Nexus</p>
      </div>

      {/* Right Panel */}
      <div className="right-panel">
        <div className="otp-card">
          <h2>OTP Verification</h2>
          <div className="otp-boxes">
            {otp.map((digit, index) => (
              <input
                key={index}
                type="text"
                maxLength="1"
                className="otp-input"
                value={digit}
                ref={(el) => (inputsRef.current[index] = el)}
                onChange={(e) => handleInputChange(e, index)}
              />
            ))}
          </div>
          <p className="resend-text">Resend in 00:30</p>
        </div>
      </div>
      {accountDeletedPopup && (
        <div className="modal-overlay">
          <div className="confirm-modal">
            <h2>Account Deleted</h2>

            <p>
              Your account has been permanently deleted. Please contact support
              if you believe this is a mistake.
            </p>

            <div className="modal-actions">
              <button
                className="confirm-btn"
                onClick={() => {
                  setAccountDeletedPopup(false);
                  navigate("/home");
                }}
              >
                OK
              </button>
            </div>
          </div>
        </div>
      )}

      {accountDisabledPopup && (
        <div className="modal-overlay">
          <div className="confirm-modal">
            <h2>Account Disabled</h2>

            <p>
              Your account is currently disabled. Would you like to reactivate
              your account?
            </p>

            <div className="modal-actions">
              <button
                className="confirm-btn"
                onClick={handleReactivateAccount}
                disabled={isEnabling}
                style={{
                  opacity: isEnabling ? 0.7 : 1,
                  cursor: isEnabling ? "not-allowed" : "pointer",
                }}
              >
                {isEnabling ? (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "8px",
                    }}
                  >
                    <span className="spinner"></span>
                    Enabling...
                  </div>
                ) : (
                  "Enable Account"
                )}
              </button>

              <button
                className="cancel-btn"
                onClick={() => {
                  setAccountDisabledPopup(false);
                  navigate("/home");
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Otp_verification;
